import { render, staticRenderFns } from "./AppBody.vue?vue&type=template&id=c2342c5e&scoped=true"
import script from "./AppBody.vue?vue&type=script&lang=js"
export * from "./AppBody.vue?vue&type=script&lang=js"
import style0 from "./AppBody.vue?vue&type=style&index=0&id=c2342c5e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2342c5e",
  null
  
)

export default component.exports